import { Autocomplete, Checkbox, FormControl, MenuItem, Select, TextField,} from "@mui/material";
import { useFetchGetallProjectsQuery } from "../../slice/logdetailSlice";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { IoIosArrowBack } from "react-icons/io";
import { useState } from "react";
import { BtnLoader } from "../../components/common/Loader";
import { filterEntities } from "../../apis/apiService";

const OTFilter = ({
  onCancel,
  view_by_project,
  view_by_status,
  from_date,
  to_date,
  project_span,
  search,
  sheet_name,
  setEditableRecords,
  setClearFilter,
}) => {
  const { data: project_list = [],} = useFetchGetallProjectsQuery();
  const [loading, setLoading] = useState(false);
  const { control, reset, handleSubmit } = useForm({
    defaultValues: {
      project_id: null,
      billing_type: "",
      status:
        sheet_name === "Pending"
          ? "PENDING"
          : sheet_name === "Approval"
          ? "APPROVED"
          : sheet_name === "Rejected"
          ? "REJECTED"
          : "",
    },
  });
  const onSubmit = async (data) => {
    setLoading(true);
    try {
      // console.log("filtered_datas :", data);
      const requestedData = {
        project_id: data.project_id,
        billing_type: data.billing_type,
        status: data.status,
        view_by_project: view_by_project,
        view_by_status: view_by_status,
        from_date: from_date,
        to_date: to_date,
        project_span: project_span,
        search: search,
      };
      const response = await filterEntities("ot/getAllOts", requestedData);
      if (response) {
        setEditableRecords(JSON.parse(JSON.stringify(response?.data?.records)));
        setClearFilter(true);
        onCancel();
        toast.success(response.message);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="row p-4">
      <form action="" className="p-2" onSubmit={handleSubmit(onSubmit)}>
        <div className="d-flex align-items-center  bg-white justify-content-between ">
          {/* <button onClick={onCancel} className="R_btn "> */}
          <button
            type="button"
            onClick={onCancel}
            className="R_btn"
          >
            <div className="d-flex text-rgba-gray align-items-center">
              <IoIosArrowBack />
              Filter
            </div>
          </button>
          <div>
            <button
              type="button"
              onClick={reset}
              className="R_btn tex-tgba-red clear-filter-btn"
            >
              Clear Filter
            </button>
          </div>
        </div>
        <div className="col-md-12 mt-3">
          <label htmlFor="project_id" className="form-label">
            Project name
          </label>
          <Controller
            name="project_id"
            control={control}
            render={({ field: { onChange, value } }) => (
              <Autocomplete
                multiple
                id="project_id"
                options={project_list || []}
                disableCloseOnSelect
                getOptionLabel={(option) => option.title}
                value={
                  (value || [])
                    .map((id) =>
                      project_list?.find((project) => project.project_id === id)
                    )
                    .filter(Boolean) || []
                }
                onChange={(event, newValue) => {
                  // Store only IDs in form state
                  const selectedIds = newValue.map(
                    (project) => project.project_id
                  );
                  onChange(selectedIds);
                }}
                renderOption={(props, option, { selected }) => (
                  <li {...props} className="d-flex align-items-center mb-2">
                    <Checkbox style={{ marginRight: 8 }} checked={selected} />
                    <strong>{option.title}</strong>
                  </li>
                )}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Enter project name" />
                )}
                ListboxProps={{
                  style: {
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "8px",
                    paddingLeft: "0",
                  },
                }}
              />
            )}
          />
        </div>
        <div className=" row my-3">
          <div className="col-md-6 ">
            <label className="form-label">Billing Type</label>
            <Controller
              name="billing_type"
              control={control}
              render={({ field }) => (
                <FormControl fullWidth>
                  <Select
                    {...field}
                    displayEmpty
                    renderValue={(selected) =>
                      selected ? (
                        selected
                      ) : (
                        <span className="lightText">Type</span>
                      )
                    }
                  >
                    <MenuItem value="BILLABLE">BILLABLE</MenuItem>
                    <MenuItem value="NON-BILLABLE">NON-BILLABLE</MenuItem>
                  </Select>
                </FormControl>
              )}
            />
          </div>
          <div className="col-md-6 ">
            <label className="form-label">Status</label>
            <Controller
              name="status"
              control={control}
              render={({ field }) => (
                <FormControl fullWidth>
                  {sheet_name !== "All" && (
                    <Select
                      {...field}
                      value={field.value || ""}
                      displayEmpty
                      renderValue={(selected) =>
                        selected ? (
                          selected
                        ) : (
                          <span className="lightText">Status</span>
                        )
                      }
                    >
                      {sheet_name === "Pending" && (
                        <MenuItem value="PENDING">PENDING</MenuItem>
                      )}
                      {sheet_name === "Approval" && (
                        <MenuItem value="APPROVED">APPROVED</MenuItem>
                      )}
                      {sheet_name === "Rejected" && (
                        <MenuItem value="REJECTED">REJECTED</MenuItem>
                      )}
                    </Select>
                  )}

                  {sheet_name === "All" && (
                    <Select
                      {...field}
                      value={field.value || ""}
                      displayEmpty
                      renderValue={(selected) =>
                        selected ? (
                          selected
                        ) : (
                          <span className="lightText">Status</span>
                        )
                      }
                    >
                      <MenuItem value="PENDING">PENDING</MenuItem>
                      <MenuItem value="APPROVED">APPROVED</MenuItem>
                      <MenuItem value="REJECTED">REJECTED</MenuItem>
                    </Select>
                  )}
                </FormControl>
              )}
            />
          </div>
        </div>
        <div className="bg-white position-absolute w-100 bottom-0 py-3">
          <div className="d-flex justify-content-left mt-3">
            <button type="submit" className="add_btn me-3" disabled={loading}>
              {loading ? (
                <>
                  <BtnLoader />
                </>
              ) : (
                "Apply"
              )}
            </button>

            <button
              type="button"
              disabled={loading}
              className="cancel_btn"
              onClick={onCancel}
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};
export default OTFilter;
